import AiSpendBreakdown from '../../../components/AiSpend/AiSpendBreakdown';

export default function AiSpendByModel() {
  return (
    <AiSpendBreakdown
      dimension="model"
      title="Model"
      description="The model or product actually charged for. A model with no catalog price shows its calls and quantities but no cost."
    />
  );
}
